import { render, staticRenderFns } from "./RegisterStudent.vue?vue&type=template&id=78be1e41&"
import script from "./RegisterStudent.vue?vue&type=script&lang=js&"
export * from "./RegisterStudent.vue?vue&type=script&lang=js&"
import style0 from "./RegisterStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports